export const transmissionColors = {
  Mecánica: '#13CE66',
  Automática: '#7D67BC',
  CVT: '#6185DB',
  Automatizada: '#FAD901',
}
